<template>
    <div>
        <Row :gutter="16" style="margin-bottom: 40px;">
            <div class="w-full flex justify-end">
                <i-select filterable v-model="analista" clearable @on-change="filterData" class="w-64">
                    <Option v-for="item in analistas" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </i-select>
                <InputNumber :active-change="false" :max="36" :min="1" v-model="periodo" class="ml-2"></InputNumber>
                <i-switch @on-change="getStats" false-value="mensal" size="large" class="m-2"
                            true-value="semanal" v-model="formato">
                    <span slot="open">SEM</span>
                    <span slot="close">MEN</span>
                </i-switch>
            </div>
        </Row>
        <BarChart
                v-if="show_graphs"
                :options="chartData"
                @click="getDetails"
        />
        <Spin size="large" fix v-if="carregar"></Spin>
        <TicketsTable :csv="csv" :analistas="analistas" :relatores="tickets_pessoas" :loading="carregar_tabela"
                      :tickets="tickets" v-if="showTable" :exibir-projeto="false" exibir-detalhes></TicketsTable>
        <DrawerTicket v-model="edit_pgd" :id="edit_id"></DrawerTicket>
    </div>
</template>

<script>

    const {moment, toQueryString} = require("../../../helpers/utils.js");
    const _ = require("lodash");
    export default {
        props: {
            reprovados: {
                type: Boolean,
                default: false
            },
            download: Boolean,
            refresh: Boolean,
            close: Boolean            
        },
        components: {
            BarChart: () => import("../../../components/charts/BarChart.vue"),
            DrawerTicket: () => import("./Drawer.vue")
        },
        data() {
            return {
                csv: false,
                exibirProjeto: false,
                analistas: [],
                analista: null,
                carregar: false,
                carregar_tabela: false,
                formato: 'semanal',
                chartData: {},
                show_graphs:true,
                showTable: false,
                tickets: [],
                stats_data: [],
                periodo: 6,
                edit_pgd: false,
                edit_id: 0,
            }
        },
        methods: {
            /**
             * Trata os dados removendo tickets repetidos
             **/
            parseData() {
                this.stats_data.map(tl => {
                    tl.aprovados.bug = _.uniqBy(tl.aprovados.bug, 'id_ticket');
                    tl.reprovados.bug = _.uniqBy(tl.reprovados.bug, 'id_ticket');
                    tl.aprovados.mel = _.uniqBy(tl.aprovados.mel, 'id_ticket');
                    tl.reprovados.mel = _.uniqBy(tl.reprovados.mel, 'id_ticket');
                    tl.aprovados.ss = _.uniqBy(tl.aprovados.ss, 'id_ticket');
                    tl.reprovados.ss = _.uniqBy(tl.reprovados.ss, 'id_ticket');
                    tl.aprovados.mvp = _.uniqBy(tl.aprovados.mvp, 'id_ticket');
                    tl.reprovados.mvp = _.uniqBy(tl.reprovados.mvp, 'id_ticket');
                    return tl;
                });
                this.filterData();
            },
            /**
             * Filtra os dados por analista
             */
            filterData() {
                const analista = this.analista;
                let stats = this.stats_data;
                this.fillData([
                    stats.map((tl) => tl.aprovados.bug.filter(item => analista ? analista == item.atribuido_a_id : item).length), // Bugs aprovados
                    stats.map((tl) => tl.reprovados.bug.filter(item => analista ? analista == item.atribuido_a_id : item).length), // Bugs reprovados
                    stats.map((tl) => tl.aprovados.mel.filter(item => analista ? analista == item.atribuido_a_id : item).length), // Mel aprovados
                    stats.map((tl) => tl.reprovados.mel.filter(item => analista ? analista == item.atribuido_a_id : item).length), // Mel reprovados
                    stats.map((tl) => tl.aprovados.ss.filter(item => analista ? analista == item.atribuido_a_id : item).length), // SS aprovados
                    stats.map((tl) => tl.reprovados.ss.filter(item => analista ? analista == item.atribuido_a_id : item).length), // SS reprovados
                    stats.map((tl) => tl.aprovados.mvp.filter(item => analista ? analista == item.atribuido_a_id : item).length), // MVP aprovados
                    stats.map((tl) => tl.reprovados.mvp.filter(item => analista ? analista == item.atribuido_a_id : item).length), // MVP reprovados
                ]);
            },
            /**
             * Preenche o objeto que é usado pelo gráfico
             */
            fillData([
                 bug_aprovados,
                 bug_reprovados,
                 mel_aprovados,
                 mel_reprovados,
                 ss_aprovados,
                 ss_reprovados,
                 mvp_aprovados,
                 mvp_reprovados
             ]) {

                const total_aprovado = bug_aprovados.map((item, idx) => item + mel_aprovados[idx] + ss_aprovados[idx] + mvp_aprovados[idx]);
                const total_reprovado = bug_reprovados.map((item, idx) => item + mel_reprovados[idx] + ss_reprovados[idx] + mvp_reprovados[idx]);

                let itemStyle = {
                    normal: {
                        barBorderWidth: "0",
                        barBorderColor: "#444444"
                    },
                    emphasis: {
                        barBorderWidth: "0",
                        barBorderColor: "#444444"
                    }
                };

                const labelTop = {
                    normal: {
                        position: 'top',
                        show: true,
                        formatter: (param) => param.value ? Math.abs(param.value) : '',
                    }
                };

                const labelBottom = {
                    normal: {
                        position: 'bottom',
                        show: true,
                        formatter: (param) => param.value ? Math.abs(param.value) : '',
                    }
                };

                this.chartData = {
                    backgroundColor: '#fff',
                    legend: {},
                    tooltip: {
                        formatter: (param) => param.seriesName + "<br />" + param.marker + ' ' + param.name + ': ' + Math.abs(param.value)
                    },
                    xAxis: {
                        data: this.legenda,
                        silent: false,
                        axisLine: {onZero: true},
                        splitArea: {show: false},
                        splitLine: {show: false}
                    },
                    yAxis: {},
                    grid: {
                        left: 50,
                        right: 50
                    },
                    series: (() => {
                        if (this.reprovados) {
                            return [
                                {
                                    name: 'Bugs',
                                    type: 'bar',
                                    stack: 'bug',
                                    color: '#d50000',
                                    data: bug_reprovados,
                                    label: labelBottom,
                                },
                                {
                                    name: 'Melhorias',
                                    type: 'bar',
                                    stack: 'mel',
                                    color: '#004d40',
                                    data: mel_reprovados,
                                    label: labelBottom,
                                },
                                {
                                    name: 'SS',
                                    type: 'bar',
                                    stack: 'ss',
                                    color: '#0d47a1',
                                    data: ss_reprovados,
                                    label: labelBottom,
                                },
                                {
                                    name: 'MVP',
                                    type: 'bar',
                                    stack: 'mvp',
                                    color: '#1a237e',
                                    data: mvp_reprovados,
                                    label: labelBottom,
                                },
                                {
                                    name: 'Total',
                                    type: 'line',
                                    color: '#263238',
                                    data: total_reprovado,
                                    label: labelBottom,
                                }
                            ];
                        } else {
                            return [
                                {
                                    name: 'Bugs',
                                    type: 'bar',
                                    stack: 'bug',
                                    color: '#ff1744',
                                    data: bug_aprovados,
                                    label: labelTop,
                                },
                                {
                                    name: 'Melhorias',
                                    type: 'bar',
                                    stack: 'mel',
                                    color: '#009688',
                                    data: mel_aprovados,
                                    label: labelTop,
                                },
                                {
                                    name: 'SS',
                                    type: 'bar',
                                    stack: 'ss',
                                    color: '#2196f3',
                                    data: ss_aprovados,
                                    label: labelTop,
                                },
                                {
                                    name: 'MVP',
                                    type: 'bar',
                                    stack: 'mvp',
                                    color: '#3f51b5',
                                    data: mvp_aprovados,
                                    label: labelTop,
                                },
                                {
                                    name: 'Total',
                                    type: 'line',
                                    color: '#607d8b',
                                    data: total_aprovado,
                                    label: labelTop,
                                },
                            ]
                        } 
                    })()
                };
            },
            getLegenda(size) {
                let legenda = [];
                if (this.formato === "semanal") {
                    legenda = ["Esta sem.", "1 sem. atrás"];
                    for (let i = 2; i < size; i++) {
                        legenda[i] = `${i} sem. atrás`;
                    }
                } else {
                    for (let i = 0; i < size; i++) {
                        legenda[i] = moment().subtract(i, 'months').format("MMMM/YY");
                    }
                }
                return legenda.reverse();
            },
            async getStats() {
                this.showTable = false;
                this.carregar = true;
                const URI = `ticket/estatisticas/qualidade?formato=${this.formato}&periodo=${this.periodo}`;
                const {data} = await this.$axios.get(URI);

                this.stats_data = data.reverse();

                this.legenda = this.getLegenda(data.length);
                this.parseData();
                this.carregar = false;
            },
            /**
             * Ao clicar em uma barra do chart, é chamado este método que trás os detalhes da Timeline
             */
            getDetails(params) {
                this.showTable = true;
                this.carregar_tabela = true;
                if (!params.selected) {
                    this.tickets = [];
                    this.$emit('download', this.showTable);
                } else {
                    this.showTable = false;
                    this.$emit('download', this.showTable);
                    return;
                }

                this.exibirProjeto = params.seriesName.toLowerCase().includes('mvp');

                const dataIndex = params.dataIndex;
                const seriesIndex = params.seriesIndex;
                const options = ['bug', 'mel', 'ss', 'mvp' ];
                const option = options[seriesIndex];
                const type = this.reprovados ? 'reprovados' : 'aprovados';
                let ids = [];
                if (seriesIndex != 5) {
                    ids = this.stats_data[dataIndex][type][option].filter(item => this.analista ? this.analista == item.atribuido_a_id : item).map(item => item.id_ticket);
                } else {
                    const ticketsTypes = this.stats_data[dataIndex]['aprovados'];
                    ids = [...ticketsTypes['bug'], ...ticketsTypes['mvp'], ...ticketsTypes['mel'], ...ticketsTypes['ss']].filter(item => this.analista ? this.analista == item.atribuido_a_id : item).map(item => item.id_ticket);;
                }

                const URI = `ticket/estatisticas/qualidade/detalhe?${toQueryString({
                    ids,
                })}`;

                this.$axios.get(URI).then(({data}) => {
                    this.tickets = data.data.map(item => {
                        item.solicitantes = item.solicitantes
                            ? JSON.parse(item.solicitantes)
                            : [];
                        return item;
                    });
                    this.carregar_tabela = false;
                    this.$emit('download', this.showTable);
                }).catch(err => {
                    console.warn(err);
                    this.showTable = false;
                    this.carregar_tabela = false;
                });
            },
            /**
             * Abre o drawer para edição do ticket
             */
            editTicket(id_ticket) {
                this.edit_id = id_ticket;
                this.edit_pgd = true;
            },
            async getAnalistas() {
                try {
                    const URI = `pessoa/analistas`;
                    const {data} = await this.$axios.get(URI);
                    /**
                     * Cria um array de objetos relacionando id como chave para o nome
                     */
                    let analistas = data.map(item => ({
                        value: item.id_pessoa,
                        label: item.nome
                    }));
                    this.analistas = analistas;
                } catch (error) {
                    console.warn(error);
                }
            },
        },
        computed: {
            tickets_pessoas() {
                return this.$store.getters['usuarios']
                    .map(item => ({
                        value: item.id_pessoa,
                        label: item.nome
                    }));
            },
        },
        created() {
            this.getAnalistas();
            this.getStats();
        },
        watch: {
            download () {
                this.csv = this.download;
            },
            refresh () {
                if (this.refresh){
                    this.formato = 'semanal'
                    this.periodo = 6;
                    this.analista = null;
                    this.showTable = false
                    this.getStats();
                }
            },
            close(){
                if (this.close){
                    this.showTable = false
                    this.show_graphs = false
                } else {
                    this.show_graphs = true
                }    
            },
            periodo: _.debounce(function () {
                this.showTable = false;
                this.getStats();
            }, 1000),
            showTable(){
                this.$emit('download',this.showTable)
            }
        },
    }
</script>

<style scoped>
    .echarts {
        width: 100%;
    }
</style>
